"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BufferSchema = void 0;
const buffer_1 = require("buffer");
const zod_1 = require("zod");
exports.BufferSchema = zod_1.z.union([zod_1.z.instanceof(Uint8Array), zod_1.z.instanceof(buffer_1.Buffer)]);
//# sourceMappingURL=bufferSchema.js.map